import React from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Typography } from "@mui/material";

const PdfViewer = ({ base64Pdf }) => {
  if (!base64Pdf) return null;

  // Convert base64 PDF to Blob URL
  const pdfBlob = new Blob([atob(base64Pdf.split(",")[1])], { type: "application/pdf" });
  const pdfUrl = URL.createObjectURL(pdfBlob);

  return (
    <Typography>
      <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
        {/* Show PDF thumbnail */}
        <iframe
          src={pdfUrl}
          width="100"
          height="120"
          style={{
            border: "1px solid #ddd",
            borderRadius: "5px",
            cursor: "pointer",
          }}
          title="PDF Preview"
        />
        <br />
        <PictureAsPdfIcon style={{ fontSize: 40, color: "red", marginTop: 5 }} />
      </a>
    </Typography>
  );
};

export default PdfViewer;
